import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

if (/\/%23\//i.test(window.location.href)) {
  window.location.href = window.location.href.replace('/%23/', '/#/');
}

function isStandaloneGameDetailPageReload() {
  try {
    var list = window.performance && window.performance.getEntriesByType;
    if (list) {
      var nav = window.performance.getEntriesByType("navigation")[0];
      if (nav && nav.type === "reload") return true;
    }
    if (
      window.performance &&
      window.performance.navigation &&
      window.performance.navigation.type ===
        window.performance.navigation.TYPE_RELOAD
    ) {
      return true;
    }
  } catch (e) {}
  return false;
}

// 加书签在游戏详情：第二次及以后从书签冷启动时，在 React 渲染前直接进首页，避免先闪一下详情页
// 页面内 refresh（如登录/注册成功后 reload）不算冷启动，仍留在游戏详情
(function standaloneGameBookmarkRedirectBeforeReact() {
  try {
    var fromNavigator = !!window.navigator.standalone;
    var fromStorage = false;
    try {
      var raw = localStorage.getItem("standalone");
      if (raw != null && raw !== "" && raw !== "null") {
        try {
          fromStorage = !!JSON.parse(raw);
        } catch (e) {
          fromStorage = true;
        }
      }
    } catch (e) {}
    if (!fromNavigator && !fromStorage) return;

    var hash = window.location.hash || "";
    if (!hash || hash.charAt(0) !== "#") return;
    var inner = hash.slice(1);
    var q = inner.indexOf("?");
    var path = q === -1 ? inner : inner.slice(0, q);
    if (path !== "/game") return;
    var qs = q === -1 ? "" : inner.slice(q + 1);
    var sp = new URLSearchParams(qs);
    if (!sp.get("id") && !sp.get("mid")) return;
    // iOS 描述文件安装后经 udid 回调带回 auto=1，勿当作书签二次冷启动
    if (sp.get("auto")) return;

    var key = "standalone_game_bookmark_first_done";
    if (!localStorage.getItem(key)) return;
    if (isStandaloneGameDetailPageReload()) return;

    var base = window.location.href.split("#")[0];
    window.location.replace(base + "#/");
  } catch (e) {}
})();

ReactDOM.render(<App/>, document.getElementById('root'));